import React, { useEffect, useState, useRef } from "react";

function useMounted() {
    const [isMounted, setIsMounted] = useState(false)


    useEffect(() => {
        setIsMounted(true)
    }, [])
    return isMounted
}

const TextSelect = ({
    format = '',
    options,
    onChange,
    selOption,
    inputId = '',
    name = '',
    onFocus = () => { },
    onBlur = () => { },
    containerClass = '',
    inputClass = '',
    menuClass = '',
    listClass = '',
    itemClass = '',
    placeholder = '',
    arrowClass = '',
}) => {
    const [selectedOption, setSelectedOption] = useState({});
    const currentSelectedOption = useRef(selectedOption);
    const [queriedOptions, setQueriedOptions] = useState([]);
    const currentQuery = useRef(queriedOptions);
    const [displayMenu, setDisplayMenu] = useState(false);
    const [preSelOption, setSelOption] = useState(false)
    const optionPool = useRef()
    const wholeInput = useRef(null);
    const selectInput = useRef(null);

    const isMounted = useMounted();
    if (selOption && !preSelOption) {
        setSelOption(selOption);
    }
    useEffect(() => {
        if (isMounted) {
            setSelectedOption(preSelOption);
        }
    }, [preSelOption])
    useEffect(() => {
        optionPool.current = options;
        setQueriedOptions(optionPool.current);

        document.addEventListener('click', (e) => {
            if (!wholeInput.current.contains(e.target)) {
                setDisplayMenu(false);
                defaultSelectedOption();
            }
        })
    }, [])

    useEffect(() => {
        if (isMounted) {
            selectInput.current.value = selectedOption.label
            onChange({ value: selectedOption.value });
            setDisplayMenu(false);
            queryOptions(selectedOption.label);
            currentSelectedOption.current = selectedOption
        }

    }, [selectedOption])
    useEffect(() => {
        currentQuery.current = queriedOptions;
    }, [queriedOptions])
    const testVal = (val) => {
        switch (format) {
            case "number" :
                val = val.replace(/[^0-9]/g, "")
                break;
            case "texto":
                val = val.replace(/[^a-zA-ZñÑ\sáéíóúÁÉÍÓÚ]/g, "");
                break;
            case "folio_mercantil":
                val = val.replace(/[^0-9a-zA-ZñÑáéíóúÁÉÍÓÚ\-\*]/g, "");
                break;
            case "alfanumerico":
                val = val.replace(/[^0-9a-zA-ZñÑ\sáéíóúÁÉÍÓÚ]/g, "");
                break;
            case "registro_patronal":
                val = val
                    ? val.match(/^[a-zA-ZñÑáéíóúÁÉÍÓÚ]{0,1}\d*]*/g)
                        ? val.match(/^[a-zA-ZñÑáéíóúÁÉÍÓÚ]{0,1}\d*]*/g)[0]
                        : ""
                    : "";
                break;
            default:
                break;
        }
        return val;
    }
    const queryOptions = (val) => {
        if (format) {
            val = testVal(val);
            selectInput.current.value = val;
        }
        setQueriedOptions(optionPool.current.filter((x) => x.label.includes(val)));
    }
    const defaultSelectedOption = () => {
        if (!selectInput.current.value && currentSelectedOption.current.label) {
            selectInput.current.value = currentSelectedOption.current.label;
            return;
        }
        if (selectInput.current.value && currentQuery.current.length < 1) {
            if (currentSelectedOption.current.label) {
                selectInput.current.value = currentSelectedOption.current.label;
            } else {
                selectInput.current.value = '';
            }
            queryOptions('')
            return;
        }
        if (currentSelectedOption.current.label
            && currentQuery.current.length > 0
            && selectInput.current.value
            && selectInput.current.value != currentSelectedOption.current.label
            && selectInput.current.value != currentQuery.current[0].label) {
            selectInput.current.value = currentSelectedOption.current.label;
            queryOptions(currentSelectedOption.current.label)
            return;
        }
        if (currentQuery.current[0] && selectInput.current.value == currentQuery.current[0].label) {
            setSelectedOption(currentQuery.current[0]);
            return;
        }
        // if(queriedOptions[0] && !queriedOptions.includes(selectedOption)){
        //     setSelectedOption(queriedOptions[0]);
        // }
    }

    return (
        <div className={containerClass}
            ref={wholeInput}>
            <input
                placeholder={selectedOption.label ? selectedOption.label : placeholder}
                name={name}
                id={inputId}
                className={inputClass}
                ref={selectInput}
                onChange={(e) => { queryOptions(e.target.value) }}
                onFocus={() => { setDisplayMenu(true), onFocus() }}
                onBlur={(e) => { onBlur(); }}
                onKeyDown={(e) => {
                    if (e.key == "Tab") {
                        setDisplayMenu(false);
                        defaultSelectedOption();
                    }
                }}
                autoComplete="off"
            />
            <img className={`${arrowClass} ${displayMenu ? `${arrowClass}-hovered` : ''}`}
                src="/assets/form/arrow.png"
                alt="arrow"
            />
            <div className={`${menuClass} ${displayMenu ? '' : `${menuClass}-closed`}`}>
                <ul className={`${listClass}`}>
                    {
                        queriedOptions.length == 0
                            ? <li
                                className={`${itemClass}`}
                                onClick={() => { setSelectedOption({ value: '', label: '' }) }}
                            >
                                No hay opciones
                            </li>
                            : queriedOptions.map(opt => (
                                <li
                                    key={opt.value}
                                    className={`${itemClass} ${opt == selectedOption ? `${itemClass}-selected` : ''}`}
                                    onClick={() => { setSelectedOption(opt) }}>
                                    {opt.label}
                                </li>
                            ))
                    }
                </ul>
            </div>
        </div>

    )
}

export default TextSelect;